import React from "react";
import { Modal } from "react-bootstrap";

/**
 * CommonModal - A reusable modal component with a premium finance-style design.
 *
 * Props:
 *   show           {boolean}   Toggle modal visibility
 *   onHide         {function}  Callback triggered when modal is closed
 *   title          {node}      Modal header title
 *   children       {node}      Modal body content
 *   footer         {node}      Modal footer content (optional)
 *   size           {string}    "sm" | "lg" | "xl" (default: "lg")
 *   fullscreen     {boolean|string}
 *   centered       {boolean}   (default: true)
 *   scrollable     {boolean}   (default: true)
 *   bodyClassName  {string}    Custom classes for modal body
 *   headerClassName {string}   Custom classes for modal header
 *   footerClassName {string}   Custom classes for modal footer
 */
const CommonModal = ({
  show,
  onHide,
  title,
  children,
  footer,
  size = "lg",
  fullscreen = false,
  centered = true,
  scrollable = true,
  bodyClassName = "",
  headerClassName = "",
  footerClassName = "",
  hideClose = false,
  ...props
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      fullscreen={true}
      centered={centered}
      scrollable={scrollable}
      className="finance-common-modal"
      {...props}
    >
      {!hideClose && onHide && (
        <button
          type="button"
          className="btn-close shadow-none position-absolute"
          onClick={onHide}
          aria-label="Close"
          style={{
            top: "20px",
            right: "20px",
            zIndex: 1051,
            padding: "10px",
          }}
        ></button>
      )}
      {(title) && (
        <Modal.Header className={`border-0 px-4 pt-4 pb-0 ${headerClassName}`}>
          {title && (
            <Modal.Title className="fs-18 fw-bold text-black w-100">
              {title}
            </Modal.Title>
          )}
        </Modal.Header>
      )}
      <Modal.Body className={`px-4 ${bodyClassName}`}>{children}</Modal.Body>
      {footer && (
        <Modal.Footer className={`border-0 px-4 pb-4 pt-2 ${footerClassName}`}>
          {footer}
        </Modal.Footer>
      )}

      <style>{`
        .finance-common-modal .modal-content {
          border-radius: 12px;
          border: none;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          position: relative;
        }
        
        .finance-common-modal .btn-close {
          background-size: 12px;
          opacity: 0.5;
          transition: all 0.2s;
        }

        .finance-common-modal .btn-close:hover {
          opacity: 1;
          transform: scale(1.1);
        }

        .finance-common-modal .modal-body {
           color: #475467;
        }

        /* 16px padding around the fullscreen modal to show the backdrop */
        .finance-common-modal .modal-dialog.modal-fullscreen {
          padding: 32px;
          width: 100%;
          max-width: none;
          height: 100%;
          margin: 0;
        }
        
        .finance-common-modal .modal-dialog.modal-fullscreen .modal-content {
          border-radius: 16px;
          height: 100%;
        }
      `}</style>
    </Modal>
  );
};

export default CommonModal;
